var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLightbulb24Px = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m14.5 15.782-.478-.878a1 1 0 0 0-.522.878zm-5 0h1a1 1 0 0 0-.522-.878zm6.5-4.076c0 1.34-.773 2.542-1.978 3.198l.956 1.756C16.762 15.69 18 13.85 18 11.706zM12 8c2.267 0 4 1.715 4 3.706h2C18 8.498 15.256 6 12 6zm-4 3.706C8 9.716 9.733 8 12 8V6c-3.256 0-6 2.498-6 5.706zm1.978 3.198C8.773 14.248 8 13.046 8 11.706H6c0 2.144 1.238 3.983 3.022 4.954zm.522 1.508v-.63h-2v.63zM10.125 16c.15 0 .375.128.375.412h-2c0 .933.786 1.588 1.625 1.588zm3.75 0h-3.75v2h3.75zm-.375.412c0-.284.226-.412.375-.412v2c.84 0 1.625-.655 1.625-1.588zm0-.63v.63h2v-.63z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  stroke: "currentColor",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M9.878 19.965h4.244a2.251 2.251 0 0 1-4.244 0zm-.128 0q-.003 0 0 0zm4.5 0q.003 0 0 0z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M12.25 2.215v1m8.25 8.786h1M18 5.672l.707-.707M6 5.672l-.707-.707M18 17.63l.707.707M6 17.63l-.707.707M2.5 12.001h1"
})));
export default SvgLightbulb24Px;